import apiClient from '../network/apiClient';
import ShowNotifications from '../utils/notification';

export class BaseApiService {
  constructor() {
    this.apiClient = apiClient;
  }

  async get(endpoint, params = {}) {
    try {
      const response = await this.apiClient.get(endpoint, { params });
      console.log(response, "rrrrrrrrrr");

      return this.handleResponse(response);
    } catch (error) {
      return this.handleError(error);
    }
  }

  async post(endpoint, data, successMessage) {
    try {
      const response = await this.apiClient.post(endpoint, data);
      console.log(response, "responce");

      return this.handleResponse(response, successMessage);
    } catch (error) {
      return this.handleError(error);
    }
  }

  async put(endpoint, data, successMessage) {
    try {
      const response = await this.apiClient.put(endpoint, data);
      return this.handleResponse(response, successMessage);
    } catch (error) {
      return this.handleError(error);
    }
  }

  async patch(endpoint, data, successMessage) {
    try {
      const response = await this.apiClient.patch(endpoint, data);
      return this.handleResponse(response, successMessage);
    } catch (error) {
      return this.handleError(error);
    }
  }

  async delete(endpoint, successMessage) {
    try {
      const response = await this.apiClient.delete(endpoint);
      return this.handleResponse(response, successMessage);
    } catch (error) {
      return this.handleError(error);
    }
  }

  // handleResponse(response) {
  //   if (response.status >= 200 && response.status < 300) {
  //     return {
  //       success: true,
  //       data: response.data,
  //       message: response.data?.message || 'Success'
  //     };
  //   }
  //   return this.handleError({
  //     response: {
  //       status: response.status,
  //       data: response.data
  //     }
  //   });
  // }

  // handleError(error) {
  //   return {
  //     success: false,
  //     error: error,
  //     message: error?.response?.data?.message || error?.message || 'Something went wrong'
  //   };
  // }

  handleResponse(response, successMessage) {
    if (response.status >= 200 && response.status < 300) {
      const method = response.config?.method?.toLowerCase();
      const isGetRequest = method === 'get';

      // Show success notification for non-GET requests or if explicitly requested via successMessage
      if (successMessage) {
        ShowNotifications.showAlertNotification(successMessage, true);
      } else if (!isGetRequest && method) {
        ShowNotifications.showAlertNotification(
          response.data?.message || 'Operation successful',
          true
        );
      }

      return {
        success: true,
        data: response.data,
        message: response.data?.message || 'Success',
        status: response.status // Keep status for compatibility
      };
    }

    return this.handleError({
      response: {
        status: response.status,
        data: response.data
      }
    });
  }

  handleError(error) {
    // Prefer explicit server message sources in this order:
    // 1. error.response.data.message (standard axios server message)
    // 2. error.data.message (some code may reject with plain object)
    // 3. error.message (axios or thrown Error)
    let errorMessage = 'Something went wrong';

    if (error?.response?.data?.message) {
      errorMessage = error.response.data.message;
    } else if (error?.data?.message) {
      errorMessage = error.data.message;
    } else if (error?.message) {
      errorMessage = error.message;
    }

    // Log full error for debugging when debug is enabled
    try {
      if (typeof console !== 'undefined') {
        console.error('API call failed:', error);
      }
    } catch (e) {
      // ignore
    }

    // Show error notification
    ShowNotifications.showAlertNotification(errorMessage, false);

    return {
      success: false,
      error: error,
      message: errorMessage
    };
  }
}
